<template>
  <div class="RedCouponOpenPopoverContainer">
    <nut-row class="bothCenter colFlex" style="margin-top: 2em">
      <span class="redTitle boldFont" style="font-size:2em">恭喜获得红包</span>
      <nut-row class="boldFont bothCenter" style="margin-top: 1em">
        <span class="couponNumber" style="font-size: 4em">{{ discount }}</span>
        <span class="couponNumber">元</span>
      </nut-row>
      <span class="wft" style="font-size:1.4em;margin-top: 2em">{{ lessonName }}</span>
      <nut-row class="bothCenter">
        <nut-icon color="rgba(255,255,255,0.8)" name="clock"></nut-icon>
        <span style="font-size:1em;color: rgba(255,255,255,0.8)">&nbsp;距离过期还有：{{ timeout }}</span>
      </nut-row>

      <img src="https://cdn.waityou.online/9beff9b3-2072-aedd-7f78-fb7bf88ee954.png"
           style="height: 60px;margin-top: 0.5em;">
      <span style="font-size:1em;color: rgba(255,255,255,0.45);">已有{{usedPeople}}人使用</span>
    </nut-row>
  </div>
</template>

<script>
export default {
  name: "RedCouponOpenPopover",
  props: {
    discount: {
      type: Number,
      default: 0
    },
    lessonName:{
      type:String,
      default:'',
    },
    usedPeople:{
      type:Number,
      default:0,
    },
  },
  data() {
    return {
      sec: 299,
      timeout: '5分0秒',
      ct: null,
    }
  },
  methods: {
    countDown() {
      this.timeout = this.secondsToMinutesAndSeconds(this.sec);
      this.sec = this.sec > 0 ? this.sec - 1 : 0;
    },
    secondsToMinutesAndSeconds(seconds) {
      if (typeof seconds !== 'number' || isNaN(seconds) || seconds < 0) {
        return "无效的输入";
      }
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;

      if (minutes === 0) {
        return `${remainingSeconds}秒`;
      } else if (remainingSeconds === 0) {
        return `${minutes}分`;
      } else {
        return `${minutes}分${remainingSeconds}秒`;
      }
    },
    init() {
      this.ct = setInterval(this.countDown, 1000)
    }
  },
  mounted() {
    this.init()
  },
  unmounted() {
    if (this.ct) {
      clearInterval(this.ct)
    }
  }
}
</script>

<style lang="scss" scoped>
.RedCouponOpenPopoverContainer {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 24em;
  height: 26.055em;
  background-image: url("https://cdn.waityou.online/5afe41d0-bcdd-bdce-7357-79b9325efbd0.png");
  background-size: cover;
  background-repeat: no-repeat;

  .redTitle {
    color: #B24C21;
  }

  .couponNumber {
    color: #D91E15;
  }
}
</style>